import type { FormFieldDef } from '@hcc/types';
import { HELP_CLASS } from './fieldStyles';

/** Wrapper styling that rings a fieldset-based control (radio/grid) in red. */
export const INVALID_GROUP_CLASS = 'rounded-md border border-danger/50 bg-danger-soft/10 p-2.5';

/** The field's label with the required star, shared by every input family. */
export function FieldLabelText({ field }: { field: FormFieldDef }) {
  return (
    <span className="font-medium text-fg-muted">
      {field.label}
      {field.required ? <span className="text-danger"> *</span> : null}
    </span>
  );
}

/** The field's help line, or nothing when unset. */
export function FieldHelp({ field }: { field: FormFieldDef }) {
  return field.help ? <span className={HELP_CLASS}>{field.help}</span> : null;
}
